import { Locales } from '@ratehub/base-ui';

// NOTE: by importing the current file, you pay the cost for importing BOTH sets of messages!
import ENGLISH_MESSAGES from '../definitions/EnglishMessages';
import FRENCH_MESSAGES from '../definitions/FrenchMessages';

/**
 * Get the react-intl message object for a locale.
 * @param {string} locale
 * @returns {object}
 */
function getLocaleMessages(locale) {
    switch (locale) {
        case Locales.FRENCH:
            return FRENCH_MESSAGES;
        case Locales.ENGLISH:
            return ENGLISH_MESSAGES;
        default:
            // Default in case this function is called with an undefined locale.
            // The message definition files themselves will scream if these are
            // not built on prod.
            return ENGLISH_MESSAGES;
    }
}

export default getLocaleMessages;
